@if (se(); as selected) {
  <div class="wrapper">
    <div class="card b-bg f-c a-i-c j-c-c">
      <div class="g-4 a-i-c">
        <img alt="gold" width="24" height="20" src="assets/images/webp/game/gold.webp" />
        <b class="t-no t-sm c-20">
          {{ selected.pay_table.length }}
        </b>
      </div>
      <span class="t-a-c t-ss sb-we c-50">{{ "tile.gold" | mnTranslate }}</span>
    </div>
    <div class="portrait">
      <ng-container [ngTemplateOutlet]="selectEl" />
    </div>
    <div class="card b-bg f-c a-i-c j-c-c">
      <b class="t-sm c-20"> x{{ selected.max_multiplier }} </b>
      <span class="t-a-c t-ss sb-we c-50">{{ "limits.max-win" | mnTranslate }}</span>
    </div>
  </div>
  <div class="landscape">
    <ng-container [ngTemplateOutlet]="selectEl" />
  </div>
}

<ng-template #selectEl>
  <div class="card select">
    @if (!di()) {
      <mn-button size="small" (clicked)="select(-1)">
        <mn-svg class="i-10" name="arrow-left" />
      </mn-button>
    }
    <div class="t-a-c f-w g-4 a-i-c j-c-c">
      <img alt="dynamite" width="20" height="20" src="assets/images/webp/game/dynamite.webp" />
      <b class="t-no c-20 t-lg">{{ se().mines_count }}</b>
    </div>
    @if (!di()) {
      <mn-button size="small" (clicked)="select(1)">
        <mn-svg class="i-10" name="arrow-right" />
      </mn-button>
    }
  </div>
</ng-template>
